import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import toast from 'react-hot-toast';

const roleLabels = { super_admin: '👑 Super Admin', admin: '🛡️ Admin', visiteur: '👁️ Visiteur' };
const roleColors = {
    super_admin: { bg: 'rgba(251,191,36,0.15)', color: '#fbbf24', border: 'rgba(251,191,36,0.3)' },
    admin: { bg: 'rgba(0,212,255,0.15)', color: '#00d4ff', border: 'rgba(0,212,255,0.3)' },
    visiteur: { bg: 'rgba(148,163,184,0.15)', color: '#94a3b8', border: 'rgba(148,163,184,0.3)' },
};

const inputStyle = {
    width: '100%', padding: '11px 14px',
    background: 'rgba(255,255,255,0.05)',
    border: '1px solid rgba(0,212,255,0.2)',
    borderRadius: 10, fontSize: 14,
    color: 'white', fontFamily: 'inherit', outline: 'none',
    boxSizing: 'border-box'
};

const ModalUtilisateur = ({ user, onClose, onSave }) => {
    const [form, setForm] = useState({
        nom: user?.nom || '',
        prenom: user?.prenom || '',
        email: user?.email || '',
        role: user?.role || 'admin',
        actif: user?.actif !== undefined ? user.actif : 1,
        password: '',
    });
    const [loading, setLoading] = useState(false);

    const handleSave = async () => {
        if (!form.nom || !form.prenom || !form.email || !form.role)
            return toast.error('Remplissez tous les champs obligatoires');
        if (!user && !form.password)
            return toast.error('Mot de passe requis pour un nouvel utilisateur');
        setLoading(true);
        try {
            if (user) {
                await api.put(`/auth/utilisateurs/${user.id}`, form);
                toast.success('Utilisateur modifié');
            } else {
                await api.post('/auth/utilisateurs', form);
                toast.success('Utilisateur créé');
            }
            onSave();
            onClose();
        } catch (err) {
            toast.error(err.response?.data?.message || 'Erreur');
        }
        setLoading(false);
    };

    return (
        <div onClick={e => e.target === e.currentTarget && onClose()} style={{ position: 'fixed', inset: 0, background: 'rgba(10,22,40,0.85)', backdropFilter: 'blur(8px)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
            <div style={{ background: 'linear-gradient(135deg,#0f2744,#0a1e3a)', border: '1px solid rgba(0,212,255,0.2)', borderRadius: 20, width: '100%', maxWidth: 520, boxShadow: '0 25px 60px rgba(0,0,0,0.6)' }}>
                <div style={{ padding: '24px 28px 20px', borderBottom: '1px solid rgba(0,212,255,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div style={{ fontSize: 18, fontWeight: 700, color: 'white' }}>{user ? '✏️ Modifier utilisateur' : '➕ Nouvel utilisateur'}</div>
                    <button onClick={onClose} style={{ width: 32, height: 32, borderRadius: 8, border: '1px solid rgba(255,255,255,0.1)', background: 'rgba(255,255,255,0.05)', cursor: 'pointer', fontSize: 16, color: 'rgba(255,255,255,0.6)' }}>✕</button>
                </div>
                <div style={{ padding: 28 }}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
                        <div>
                            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: 'rgba(255,255,255,0.6)', marginBottom: 7 }}>Prénom <span style={{ color: '#ef4444' }}>*</span></label>
                            <input style={inputStyle} value={form.prenom} onChange={e => setForm(f => ({ ...f, prenom: e.target.value }))} placeholder="Prénom" />
                        </div>
                        <div>
                            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: 'rgba(255,255,255,0.6)', marginBottom: 7 }}>Nom <span style={{ color: '#ef4444' }}>*</span></label>
                            <input style={inputStyle} value={form.nom} onChange={e => setForm(f => ({ ...f, nom: e.target.value }))} placeholder="Nom" />
                        </div>
                    </div>
                    <div style={{ marginBottom: 16 }}>
                        <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: 'rgba(255,255,255,0.6)', marginBottom: 7 }}>Email <span style={{ color: '#ef4444' }}>*</span></label>
                        <input type="email" style={inputStyle} value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} placeholder="email@csform.fr" />
                    </div>
                    <div style={{ marginBottom: 16 }}>
                        <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: 'rgba(255,255,255,0.6)', marginBottom: 7 }}>Rôle <span style={{ color: '#ef4444' }}>*</span></label>
                        <select style={{ ...inputStyle, cursor: 'pointer' }} value={form.role} onChange={e => setForm(f => ({ ...f, role: e.target.value }))}>
                            <option value="super_admin">👑 Super Admin</option>
                            <option value="admin">🛡️ Admin</option>
                            <option value="visiteur">👁️ Visiteur</option>
                        </select>
                    </div>
                    <div style={{ marginBottom: 16 }}>
                        <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: 'rgba(255,255,255,0.6)', marginBottom: 7 }}>
                            {user ? 'Nouveau mot de passe (laisser vide = inchangé)' : 'Mot de passe *'}
                        </label>
                        <input type="password" style={inputStyle} value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} placeholder="••••••••" />
                    </div>
                    {user && (
                        <div style={{ marginBottom: 16 }}>
                            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: 'rgba(255,255,255,0.6)', marginBottom: 7 }}>Statut</label>
                            <select style={{ ...inputStyle, cursor: 'pointer' }} value={form.actif} onChange={e => setForm(f => ({ ...f, actif: parseInt(e.target.value) }))}>
                                <option value={1}>✅ Actif</option>
                                <option value={0}>🚫 Désactivé</option>
                            </select>
                        </div>
                    )}
                    <div style={{ marginTop: 8, padding: 14, background: 'rgba(0,212,255,0.05)', border: '1px solid rgba(0,212,255,0.1)', borderRadius: 10, fontSize: 12, color: 'rgba(255,255,255,0.4)', lineHeight: 1.8 }}>
                        <strong style={{ color: 'rgba(0,212,255,0.7)' }}>Rôles :</strong><br />
                        👑 <strong style={{ color: '#fbbf24' }}>Super Admin</strong> — Accès total + gestion utilisateurs<br />
                        🛡️ <strong style={{ color: '#00d4ff' }}>Admin</strong> — Gestion des messages<br />
                        👁️ <strong style={{ color: '#94a3b8' }}>Visiteur</strong> — Lecture seule
                    </div>
                    <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
                        <button onClick={onClose} style={{ flex: 1, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 10, padding: '11px', fontSize: 14, fontWeight: 600, color: 'rgba(255,255,255,0.6)', cursor: 'pointer', fontFamily: 'inherit' }}>Annuler</button>
                        <button onClick={handleSave} disabled={loading} style={{ flex: 2, background: 'linear-gradient(135deg,#1e6fe0,#00d4ff)', border: 'none', borderRadius: 10, padding: '11px', fontSize: 14, fontWeight: 700, color: 'white', cursor: 'pointer', fontFamily: 'inherit' }}>
                            {loading ? '⏳ Enregistrement...' : user ? '✅ Modifier' : '➕ Créer'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const UtilisateursPage = () => {
    const [utilisateurs, setUtilisateurs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalUser, setModalUser] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const load = async () => {
        setLoading(true);
        try {
            const { data } = await api.get('/auth/utilisateurs');
            setUtilisateurs(data.utilisateurs);
        } catch {
            toast.error('Erreur chargement');
        }
        setLoading(false);
    };

    useEffect(() => { load(); }, []);

    const handleDelete = async (user) => {
        if (!window.confirm(`Supprimer ${user.prenom} ${user.nom} ?`)) return;
        try {
            await api.delete(`/auth/utilisateurs/${user.id}`);
            toast.success('Utilisateur supprimé');
            load();
        } catch (err) {
            toast.error(err.response?.data?.message || 'Erreur');
        }
    };

    return (
        <div>
            <div style={{ background: 'rgba(255,255,255,0.03)', backdropFilter: 'blur(10px)', border: '1px solid rgba(0,212,255,0.1)', borderRadius: 16, overflow: 'hidden' }}>
                <div style={{ padding: '20px 24px', borderBottom: '1px solid rgba(0,212,255,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div>
                        <div style={{ fontSize: 15, fontWeight: 700, color: 'white' }}>👥 Gestion des utilisateurs</div>
                        <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)', marginTop: 2 }}>{utilisateurs.length} utilisateur(s)</div>
                    </div>
                    <button onClick={() => { setModalUser(null); setShowModal(true); }} style={{ background: 'linear-gradient(135deg,#1e6fe0,#00d4ff)', border: 'none', borderRadius: 10, padding: '10px 20px', fontSize: 14, fontWeight: 700, color: 'white', cursor: 'pointer', fontFamily: 'inherit', boxShadow: '0 0 20px rgba(0,212,255,0.2)' }}>
                        ➕ Nouvel utilisateur
                    </button>
                </div>

                <div style={{ overflowX: 'auto' }}>
                    {loading ? (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 200 }}>
                            <div style={{ width: 36, height: 36, border: '3px solid rgba(0,212,255,0.2)', borderTopColor: '#00d4ff', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }}></div>
                            <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
                        </div>
                    ) : (
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                                <tr>
                                    {['Utilisateur', 'Email', 'Rôle', 'Statut', 'Dernière connexion', 'Actions'].map(h => (
                                        <th key={h} style={{ textAlign: 'left', padding: '12px 16px', fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.8px', color: 'rgba(0,212,255,0.6)', borderBottom: '1px solid rgba(0,212,255,0.1)', whiteSpace: 'nowrap' }}>{h}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {utilisateurs.map(u => {
                                    const rc = roleColors[u.role] || roleColors.visiteur;
                                    return (
                                        <tr key={u.id} style={{ borderBottom: '1px solid rgba(255,255,255,0.03)', transition: 'background 0.15s' }} onMouseEnter={e => e.currentTarget.style.background = 'rgba(0,212,255,0.05)'} onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                                            <td style={{ padding: '14px 16px' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                                    <div style={{ width: 36, height: 36, background: 'linear-gradient(135deg,#1e6fe0,#00d4ff)', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 700, color: 'white', flexShrink: 0 }}>
                                                        {u.prenom?.[0]}{u.nom?.[0]}
                                                    </div>
                                                    <div style={{ fontWeight: 600, color: 'white', fontSize: 13 }}>{u.prenom} {u.nom}</div>
                                                </div>
                                            </td>
                                            <td style={{ padding: '14px 16px', fontSize: 13, color: 'rgba(255,255,255,0.6)' }}>{u.email}</td>
                                            <td style={{ padding: '14px 16px' }}>
                                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '4px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600, background: rc.bg, color: rc.color, border: `1px solid ${rc.border}` }}>{roleLabels[u.role]}</span>
                                            </td>
                                            <td style={{ padding: '14px 16px' }}>
                                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '4px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600, background: u.actif ? 'rgba(5,150,105,0.15)' : 'rgba(239,68,68,0.15)', color: u.actif ? '#34d399' : '#f87171', border: `1px solid ${u.actif ? 'rgba(5,150,105,0.3)' : 'rgba(239,68,68,0.3)'}` }}>
                                                    {u.actif ? '✅ Actif' : '🚫 Désactivé'}
                                                </span>
                                            </td>
                                            <td style={{ padding: '14px 16px', fontSize: 12, color: 'rgba(255,255,255,0.4)' }}>
                                                {u.derniere_connexion ? new Date(u.derniere_connexion).toLocaleDateString('fr-FR') + ' ' + new Date(u.derniere_connexion).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }) : '—'}
                                            </td>
                                            <td style={{ padding: '14px 16px' }}>
                                                <div style={{ display: 'flex', gap: 6 }}>
                                                    <button onClick={() => { setModalUser(u); setShowModal(true); }} style={{ background: 'rgba(0,212,255,0.1)', border: '1px solid rgba(0,212,255,0.2)', borderRadius: 8, padding: '6px 12px', fontSize: 13, fontWeight: 600, color: '#00d4ff', cursor: 'pointer', fontFamily: 'inherit' }}>✏️</button>
                                                    <button onClick={() => handleDelete(u)} style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.2)', borderRadius: 8, padding: '6px 12px', fontSize: 13, fontWeight: 600, color: '#f87171', cursor: 'pointer', fontFamily: 'inherit' }}>🗑️</button>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>

            {showModal && <ModalUtilisateur user={modalUser} onClose={() => setShowModal(false)} onSave={load} />}
        </div>
    );
};

export default UtilisateursPage;